import reducer from './auth.reducer'
import * as actions from './auth.actions'
import * as selectors from './auth.selectors'

export const authServiceActions = actions
export const authServiceSelectors = selectors
export const authServiceReducers = reducer
